import { TreasureService } from '../services/treasure';

export class TreasurePurchase {
  private treasureService = new TreasureService();

  async purchaseTreasure(partnerId: string, priceInDollars: number = 5): Promise<void> {
    try {
      const priceCents = Math.round(priceInDollars * 100);
      
      const { checkout_url } = await this.treasureService.createPaymentIntent(
        partnerId, 
        priceCents
      );

      // Redirect to Stripe Checkout (same as subscription system)
      window.location.href = checkout_url;
      
    } catch (error) {
      console.error('Purchase failed:', error);
      throw error;
    }
  }

  renderPurchaseButton(partnerId: string): HTMLElement {
    const button = document.createElement('button');
    button.className = 'purchase-treasure-btn';
    button.textContent = 'Buy Merchant Token ($5.00)';
    
    button.addEventListener('click', async () => {
      button.disabled = true;
      button.textContent = 'Redirecting to payment...';
      
      try {
        await this.purchaseTreasure(partnerId);
        // Will redirect to Stripe, so this won't execute
      } catch (error) {
        alert(`Purchase failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
        button.disabled = false;
        button.textContent = 'Buy Merchant Token ($5.00)';
      }
    });

    return button;
  }
}
